var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{class:`z-icon iconfont icon-${_vm.type}`,style:(_vm.styles),on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }